import { MAIN_OFFICE_DEPARTMENT_ID } from "@features/department/constants/departmentIds";

export type DepartmentSelectItem = {
  department_id: number;
  name: string;
};

export type PartitionedDepartments<T extends DepartmentSelectItem> = {
  mainOffice: T | undefined;
  others: T[];
};

/**
 * Pins Main Office (id MAIN_OFFICE_DEPARTMENT_ID) above other departments for selects.
 * Others are sorted by display name.
 */
export function partitionDepartmentsForSelect<T extends DepartmentSelectItem>(
  departments: T[]
): PartitionedDepartments<T> {
  let mainOffice: T | undefined;
  const others: T[] = [];

  for (const dept of departments) {
    if (Number(dept.department_id) === MAIN_OFFICE_DEPARTMENT_ID) {
      mainOffice = dept;
    } else {
      others.push(dept);
    }
  }

  others.sort((a, b) => (a.name || "").localeCompare(b.name || ""));

  return { mainOffice, others };
}
